/**
 * Slide Out Content - JavaScript functionality
 * Handles overlay interactions, mobile panel toggles, and carousel navigation
 */

document.addEventListener('DOMContentLoaded', function () {
  // ========================================
  // DESKTOP OVERLAY FUNCTIONALITY
  // ========================================
  
  const overlayTabs = document.querySelectorAll('.slide-out-content__overlay-tab');
  const overlays = document.querySelectorAll('.slide-out-content__overlay');

  // Handle overlay tab clicks
  overlayTabs.forEach((tab) => {
    tab.addEventListener('click', function (event) {
      if (event.target.closest('.slide-out-content__tab-label--link')) {
        return;
      }

      const sectionEl = this.closest('.slide-out-content');
      const isTwoStep = sectionEl?.classList.contains('slide-out-content--two-step');
      // One-step mode: hover already fully opens the panel. Skip pin-on-click for
      // pointer devices that support hover so a click doesn't lock the panel open.
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!isTwoStep && canHover) {
        return;
      }

      const overlayId = this.getAttribute('data-overlay-id');
      const overlay = document.querySelector(`[data-overlay-id="${overlayId}"].slide-out-content__overlay`);

      if (overlay) {
        // Close any other open overlays
        overlays.forEach((over) => {
          if (over !== overlay) {
            over.classList.remove('is-active');
            const otherTab = document.querySelector(`.slide-out-content__overlay-tab[data-overlay-id="${over.dataset.overlayId}"]`);
            if (otherTab) {
              otherTab.setAttribute('aria-expanded', 'false');
            }
          }
        });

        overlay.classList.toggle('is-active');
        this.setAttribute('aria-expanded', String(overlay.classList.contains('is-active')));
      }
    });
  });

  // Handle overlay close button clicks
  const closeButtons = document.querySelectorAll('.slide-out-content__overlay-close');
  closeButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const overlayId = this.getAttribute('data-overlay-id');
      const overlay = document.querySelector(`[data-overlay-id="${overlayId}"].slide-out-content__overlay`);

      if (overlay) {
        overlay.classList.remove('is-active');
        const tab = document.querySelector(`.slide-out-content__overlay-tab[data-overlay-id="${overlayId}"]`);
        if (tab) {
          tab.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  // Handle overlay background clicks (close overlay)
  overlays.forEach((overlay) => {
    overlay.addEventListener('click', function (e) {
      if (e.target === this) {
        this.classList.remove('is-active');
        const tab = document.querySelector(`.slide-out-content__overlay-tab[data-overlay-id="${this.dataset.overlayId}"]`);
        if (tab) {
          tab.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  // Handle escape key to close overlays
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      overlays.forEach((overlay) => {
        overlay.classList.remove('is-active');
        const tab = document.querySelector(`.slide-out-content__overlay-tab[data-overlay-id="${overlay.dataset.overlayId}"]`);
        if (tab) {
          tab.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // ========================================
  // CAROUSEL NAVIGATION
  // ========================================

  // Handle slideshow arrows for slide-out-content
  document.addEventListener('click', function (e) {
    const readMoreButton = e.target.closest('.slide-out-content__read-more[data-article-url]');
    if (readMoreButton) {
      const articleUrl = readMoreButton.getAttribute('data-article-url');
      if (articleUrl) {
        window.location.href = articleUrl;
      }
      return;
    }

    if (e.target.closest('.slide-out-content-arrow--prev')) {
      e.preventDefault();
      e.stopPropagation();
      const slideShow = e.target.closest('.slide-out-content').querySelector('slide-show');
      if (slideShow && slideShow.flickity) {
        slideShow.flickity.previous();
        updateArrowStates(slideShow);
      }
    }

    if (e.target.closest('.slide-out-content-arrow--next')) {
      e.preventDefault();
      e.stopPropagation();
      const slideShow = e.target.closest('.slide-out-content').querySelector('slide-show');
      if (slideShow && slideShow.flickity) {
        slideShow.flickity.next();
        updateArrowStates(slideShow);
      }
    }
  });

  // Function to update arrow disabled states
  function updateArrowStates(slideShow) {
    if (!slideShow || !slideShow.flickity) return;

    const flickity = slideShow.flickity;
    const prevBtn = slideShow.closest('.slide-out-content').querySelector('.slide-out-content-arrow--prev');
    const nextBtn = slideShow.closest('.slide-out-content').querySelector('.slide-out-content-arrow--next');

    if (prevBtn) {
      if (flickity.selectedIndex === 0) {
        prevBtn.classList.add('slideshow-arrow--disabled');
      } else {
        prevBtn.classList.remove('slideshow-arrow--disabled');
      }
    }

    if (nextBtn) {
      if (flickity.selectedIndex === flickity.slides.length - 1) {
        nextBtn.classList.add('slideshow-arrow--disabled');
      } else {
        nextBtn.classList.remove('slideshow-arrow--disabled');
      }
    }
  }

  // Initialize arrow states for all slide-out-content carousels
  document.querySelectorAll('.slide-out-content slide-show').forEach((slideShow) => {
    if (slideShow.flickity) {
      updateArrowStates(slideShow);

      // Listen for Flickity events to update arrow states
      slideShow.flickity.on('change', () => {
        updateArrowStates(slideShow);
      });
    }
  });

  // ========================================
  // MOBILE FUNCTIONALITY
  // ========================================

  const mobileOverlays = document.querySelectorAll('.slide-out-content__mobile-overlay');
  mobileOverlays.forEach((wrapper) => {
    const tab = wrapper.querySelector('.slide-out-content__mobile-tab');
    const panel = wrapper.querySelector('.slide-out-content__mobile-panel');
    if (!tab || !panel) return;

    tab.addEventListener('click', (event) => {
      if (event.target.closest('.slide-out-content__mobile-tab-label-link')) {
        return;
      }

      const isOpen = tab.getAttribute('aria-expanded') === 'true';
      const slideOutSection = wrapper.closest('.slide-out-content');

      tab.setAttribute('aria-expanded', String(!isOpen));
      
      if (isOpen) {
        closeMobilePanel(wrapper, panel);
      } else {
        openMobilePanel(wrapper, panel);
      }
    });

    setupMobileCarousel(wrapper);
  });

  // ========================================
  // MOBILE HELPER FUNCTIONS
  // ========================================

  function closeMobilePanel(wrapper, panel) {
    // Start closing animation
    wrapper.classList.add('is-closing');
    wrapper.classList.remove('is-open');

    // Hide tab label and icon inner elements with smooth fade out
    const tabLabelInner = wrapper.querySelector('.slide-out-content__mobile-tab-label-inner');
    const tabIconInner = wrapper.querySelector('.tab-icon-inner');

    fadeOutElement(tabLabelInner);
    fadeOutElement(tabIconInner);

    // Hide panel after animation completes
    setTimeout(() => {
      panel.setAttribute('hidden', '');
      wrapper.classList.remove('is-closing');
    }, 800);
  }

  function openMobilePanel(wrapper, panel) {
    // Show panel and start overlay animation
    panel.removeAttribute('hidden');
    wrapper.classList.add('is-open');

    // Delay showing tab label and icon inner elements
    const tabLabelInner = wrapper.querySelector('.slide-out-content__mobile-tab-label-inner');
    const tabIconInner = wrapper.querySelector('.tab-icon-inner');

    fadeInElement(tabLabelInner, 1000);
    fadeInElement(tabIconInner, 1000);
  }

  function fadeOutElement(element) {
    if (!element) return;
    
    element.style.opacity = '0';
    element.style.transition = 'opacity 0.3s ease-in-out';
    
    // For elements that need display control (like label-inner)
    if (element.classList.contains('slide-out-content__mobile-tab-label-inner')) {
      setTimeout(() => {
        element.style.display = 'none';
      }, 300);
    }
  }

  function fadeInElement(element, delay = 0) {
    if (!element) return;
    
    // For elements that need display control (like label-inner)
    if (element.classList.contains('slide-out-content__mobile-tab-label-inner')) {
      element.style.display = 'none';
      element.style.opacity = '0';
      element.style.transition = 'opacity 0.3s ease-in-out';
      
      setTimeout(() => {
        element.style.display = 'block';
        setTimeout(() => {
          element.style.opacity = '1';
        }, 10);
      }, delay);
    } else {
      // For elements that only need opacity control (like tab-icon-inner)
      element.style.opacity = '0';
      element.style.transition = 'opacity 0.3s ease-in-out';
      
      setTimeout(() => {
        element.style.opacity = '1';
      }, delay);
    }
  }

  function setupMobileCarousel(wrapper) {
    const mobilePrevBtn = wrapper.querySelector('.slide-out-content-arrow--prev');
    const mobileNextBtn = wrapper.querySelector('.slide-out-content-arrow--next');
    const mobileSlideShow = wrapper.querySelector('.slide-out-content__blog-section--mobile slide-show');

    if (mobilePrevBtn && mobileSlideShow) {
      mobilePrevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (mobileSlideShow && mobileSlideShow.flickity) {
          mobileSlideShow.flickity.previous();
          updateMobileArrowStates(mobileSlideShow, wrapper);
        }
      });
    }

    if (mobileNextBtn && mobileSlideShow) {
      mobileNextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (mobileSlideShow && mobileSlideShow.flickity) {
          mobileSlideShow.flickity.next();
          updateMobileArrowStates(mobileSlideShow, wrapper);
        }
      });
    }

    // Listen for carousel changes (swipe/touch navigation)
    if (mobileSlideShow && mobileSlideShow.flickity) {
      updateMobileArrowStates(mobileSlideShow, wrapper);
      
      mobileSlideShow.flickity.on('change', () => {
        updateMobileArrowStates(mobileSlideShow, wrapper);
      });
    }
  }

  function updateMobileArrowStates(slideShow, wrapper) {
    if (!slideShow || !slideShow.flickity) return;

    const flickity = slideShow.flickity;
    const prevBtn = wrapper.querySelector('.slide-out-content-arrow--prev');
    const nextBtn = wrapper.querySelector('.slide-out-content-arrow--next');

    if (prevBtn) {
      if (flickity.selectedIndex === 0) {
        prevBtn.classList.add('slideshow-arrow--disabled');
      } else {
        prevBtn.classList.remove('slideshow-arrow--disabled');
      }
    }

    if (nextBtn) {
      if (flickity.selectedIndex === flickity.slides.length - 1) {
        nextBtn.classList.add('slideshow-arrow--disabled');
      } else {
        nextBtn.classList.remove('slideshow-arrow--disabled');
      }
    }
  }
});
